$(function (e) {
	//Remove Error Message
	$('body').on('input change', '#address', function(e) {
        $('#addressError').addClass('d-none');
    });

	$.ajaxSetup({
	    headers: {
	        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
	    }
	});

	/* Rewards part carousel trigger  */
	$('body').on('slide.bs.carousel', '#rewards_carousel', function onSlide(ev) {
		var element_id = ev.relatedTarget.id;
		$('#redeem_status div').addClass('d-none');
		$('#redeem_status div[data-id='+element_id+']').removeClass('d-none');
		$('#reward_id').val(element_id);
	});

	function addOrReplaceSelectedTab(value) {
       	var current_url = window.location.href;
       	// Parse the URL to extract the query parameters
    	var url_parts = current_url.split('?');
    	var base_url = url_parts[0];
    	var query_params = url_parts[1] ? url_parts[1].split('&') : [];

    	// Check if the parameter already exists
       	var param_exists = false;

       	query_params = query_params.map(function (param) {
           	var pair = param.split('=');
           	if (pair[0] === 'selected_tab') {
               param_exists = true;
               return 'selected_tab=' + encodeURIComponent(value);
           	}
           	return param;
       	});

       	// If the parameter doesn't exist, add it
        if (!param_exists) {
            query_params.push('selected_tab=' + encodeURIComponent(value));
        }

        // Rebuild the URL with the modified parameters
        var modified_url = base_url + '?' + query_params.join('&');

        // Modify the browser history without triggering a full page reload
        history.pushState({}, document.title, modified_url);
    }

	/* Hut Reward Header Tab Event */
	$('body').on('click', '.hut-rewards-detail-header-tab', function(e){
		if( !$(this).hasClass('active') ){
			$('.hut-rewards-detail-header-tab.active').removeClass('active');
			$(this).addClass('active');
			var param_value = $(this).data('section');
			addOrReplaceSelectedTab(param_value);
		}else{
			e.stopPropagation();
		}
	});

	/* Remove Address modal open */
	$('body').on('click', '.remove-address', function(e){
		e.preventDefault();
		var favourite = $(this).attr('data-favourite');
		if( favourite == 1 ){
			showModal('cannot-remove-address-modal', {backdrop:'static', keyboard:false});
		}else{
			var url = $(this).attr('data-url');
			$('#remove-address-modal form').attr('data-url', url);
			showModal('remove-address-modal', {backdrop:'static', keyboard:false});
		}
	});

	/* Remove Address Form submit*/
	$('body').on('submit', '#remove_address', function(e){
		e.preventDefault();
		var url = $(this).attr('data-url');
		$.ajax({
        	type: 'POST',
        	url: url,
        	success: function(data){
        		$.each(data, function(k, v){
        			if( k == 'success' ){
        				var fields = $('#address-'+v).nextAll();
						$.each(fields, function() {
						    var current_number = parseInt($(this).find('.runing-number').text());
						    $(this).find('.runing-number').text(current_number - 1);
						});
						$('#address-'+v).remove();
        			}else{
        				$('#app').prepend(`
        					<div class="alert alert-danger alert-block">
							    <small>`+k+`</small>
							</div>
        				`);
        			}
        			// hideModal('remove-address-modal');
        			window.location.reload();
        		});
        	}
        });
	});

	/* Favourite button */
	$('body').on('click', '.favourite-button', function(e){
		e.preventDefault();
		var url = $(this).attr('data-url');
		var favourite_button = $(this);
		$.ajax({
        	type: 'POST',
        	url: url,
        	success: function(data){
        		$.each(data, function(k, v){
        			if( k == 'success' ){
						$('.phc-star-fill').removeClass('phc-star-fill').addClass('favourite-button phc-star');
						favourite_button.removeClass('favourite-button').addClass('phc-star-fill');
        				$('button.remove-address').attr('data-favourite', 0);
        				favourite_button.closest('.member-address-single').children('.member-address-single-action').children('button.remove-address').attr('data-favourite', 1);
        				window.location.reload();
        			}else{
        				$('#app').prepend(`
        					<div class="alert alert-danger alert-block">
							    <small>`+v+`</small>
							</div>
        				`);
        			}
        		});
        	}
        });
	});
});